<script>
import Card from "../../components/Card.vue";
import LoadingSpinner from "../../components/LoadingSpinner.vue";
import AuditorList from "./components/AuditorList.vue";

import FirstSection from "./components/FirstSection.vue";
import SecondSection from "./components/SecondSection.vue";
import ReportOptions from "./components/ReportOptions.vue";
import AboutTheCompany from "./components/AboutTheCompany.vue";
import Facilities from "./components/Facilities.vue";
import VMV from './components/VMV.vue';
import Milestones from './components/Milestones.vue';
import Products from './components/Products.vue';
import Networks from './components/Networks.vue';
import Memberships from './components/Memberships.vue';
import Awards from './components/Awards.vue';
import CarbonOptions from "./components/CarbonOptions.vue";

import { mapState } from 'vuex';

export default {
  components: {
    Card,
    LoadingSpinner,
    AuditorList,

    FirstSection,
    SecondSection,
    ReportOptions,
    AboutTheCompany,
    Facilities,
    VMV,
    Milestones,
    Products,
    Networks,
    Memberships,
    Awards,
    CarbonOptions,
  },

  data() {
    return {
      loading: true,
      years: [],

      facilityVisible: true,
    }
  },
  computed: {
    selectedCompanyId() {
      return this.$user.company_id;
    },

    ...mapState('app', [
      'companyLicence',
    ]),

    isAuditor() {
      if (!this.companyLicence) return false;
      return this.companyLicence.plan_id == -1;
    },

    reportingYear() {
      const currentYear = new Date().getFullYear();
      return currentYear-1;
    },

    hasCarbon() {
      for (const key in this.companyLicence.optionalModules) {
        if (!Object.prototype.hasOwnProperty.call(this.companyLicence.optionalModules, key)) continue;
        const value = this.companyLicence.optionalModules[key];
        
        if (value === 8) { // carbon module, needs to be in a separate config file when rewriting
          return true;
        }
      }

      return false;
    },
  },

  methods: {
    async setupYears() {
      let currYear = new Date().getFullYear();
      while (currYear > 1900) {
        this.years.push(currYear);
        currYear--;
      }
    }
  },

  mounted() {
    this.setupYears()
      .then(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      })
  },
}

</script>


<template>
  <div id="companyProfile">
    <div v-if="loading" class="flex-all-centered-row" style="padding: 1em; font-size: 3em; text-align: center;">
      <LoadingSpinner />
    </div>
    <div v-else>
      <br>

      <Card>
        <FirstSection :selectedCompanyId="selectedCompanyId" :userInfo="$user" />
      </Card>

      <Card v-if="!isAuditor">
        <AuditorList />
      </Card>

      <Card v-if="!isAuditor">
        <ReportOptions :selectedCompanyId="selectedCompanyId" />
      </Card>

      <Card>
        <SecondSection :selectedCompanyId="selectedCompanyId" />
      </Card>

      <h3 class="special-h3">
        {{ $t('companyProfile.modal3.header') }}
      </h3>
      <Card>
        <AboutTheCompany :selectedCompanyId="selectedCompanyId" />
      </Card>

      <h3 class="special-h3">
        {{ $t('companyProfile.modal4.header') }}
      </h3>
      <Card v-if="facilityVisible">
        <Facilities :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" 
          @facility-count="(count) => facilityVisible = count > 1" 
        />
      </Card>

      <div v-html="$t('companyProfile.facilities_contact_us')"></div>

      <div style="
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        align-content: center;
        margin-bottom: 4em;
      ">
        <div style="flex: 1; margin-right: 1.5em; margin-top: .5em;">
          <h3 class="special-h3">
            {{ $t('companyProfile.modal5.header1') }}
          </h3>
          <Card style="height: 100%;">
            <VMV :selectedCompanyId="selectedCompanyId" :type="'vision'" />
          </Card>
        </div>

        <div style="flex: 1; margin-top: .5em;">
          <h3 class="special-h3">
            {{ $t('companyProfile.modal5.header2') }}
          </h3>
          <Card style="height: 100%;">
            <VMV :selectedCompanyId="selectedCompanyId" :type="'mission'" />
          </Card>
        </div>

        <div style="flex: 1; margin-left: 1.5em; margin-top: .5em;">
          <h3 class="special-h3">
            {{ $t('companyProfile.modal5.header3') }}
          </h3>
          <Card style="height: 100%;">
            <VMV :selectedCompanyId="selectedCompanyId" :type="'values'" />
          </Card>
        </div>
      </div>

      <br><br>

      <h3 class="special-h3" v-if="!isAuditor">
        {{ $t('companyProfile.modal6.header') }}
      </h3>
      <Card v-if="!isAuditor">
        <Milestones :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

      <h3 class="special-h3" v-if="!isAuditor">
        {{ $t('companyProfile.modal7.header') }}
      </h3>
      <Products v-if="!isAuditor" :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />

      <h3 class="special-h3" v-if="!isAuditor && hasCarbon">
        {{ $t('carbon-options.title') }} - 
        <span id="reporting-year-message">
          {{ $t('carbon-options.reporting-year-message') }} ({{ reportingYear }})
        </span>
      </h3>
      <Card v-if="!isAuditor && hasCarbon">
        <CarbonOptions :selectedCompanyId="selectedCompanyId" />
      </Card>

      <h3 class="special-h3" v-if="!isAuditor">
        {{ $t('companyProfile.modal8.header') }}
      </h3>
      <Card v-if="!isAuditor">
        <Networks :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

      <h3 class="special-h3" v-if="!isAuditor">
        {{ $t('companyProfile.modal9.header') }}
      </h3>
      <Card v-if="!isAuditor">
        <Memberships :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

      <h3 class="special-h3" v-if="!isAuditor">
        {{ $t('companyProfile.modal10.header') }}
      </h3>
      <Card v-if="!isAuditor">
        <Awards :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

    </div>
  </div>
</template>

<style lang="scss">
.special-h3 {
  color: black !important;
  font-style: italic !important;
  font-weight: bolder !important;
  text-align: left !important;
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif !important;
}

#reporting-year-message {
  vertical-align: middle;
  font-size: .9rem;
  color: var(--carbon-alternative);
}
</style>